// 引入vue
import Vue from 'vue'
// 引入vuex
import Vuex from 'vuex'
import user from './modules/user';
import ai from './modules/ai';
// 使用vuex插件
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    ai
  }
})


